"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFilterDialogItem = void 0;
const react_1 = __importStar(require("react"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox/Checkbox"));
const table_context_1 = require("./table-context");
/**
 * Filter dialog item.
 */
function TableFilterDialogItem({ filter, state, onToggle, onChangeValue, onChangeFilterState, }) {
    const { classes } = react_1.useContext(table_context_1.TableContext);
    const { FilterComponent } = filter;
    return (react_1.default.createElement("div", { className: classes.filterDialogItem },
        react_1.default.createElement(FormControlLabel_1.default, { className: classes.columnDialogItemLabel, classes: { label: classes.dialogCheckBoxLabel }, label: filter.label, control: react_1.default.createElement(Checkbox_1.default, { checked: state === null || state === void 0 ? void 0 : state.enabled, color: "primary", onChange: onToggle }) }),
        (state === null || state === void 0 ? void 0 : state.enabled) && (react_1.default.createElement(FilterComponent, { filter: filter, state: state, disabled: !(state === null || state === void 0 ? void 0 : state.enabled), value: state.value, onChange: onChangeValue, onChangeState: onChangeFilterState }))));
}
exports.TableFilterDialogItem = TableFilterDialogItem;
//# sourceMappingURL=table-filter-dialog-item.js.map